// mega-menu-hover.js — stabil hover + delay close (desktop only)
document.addEventListener('DOMContentLoaded', function () {
  // csak desktop és nem touch eszköz
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  if ('ontouchstart' in window) return;

  var menus = document.querySelectorAll('header .mega-menu, .header .mega-menu');

  if (!menus.length) return;

  menus.forEach(function(menu) {
    var closeTimer = null;
    var panel = menu.querySelector('.mega-menu__content');

    function openMenu() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      try { menu.setAttribute('open', ''); } catch(e){}
      menu.classList.add('hover-open');
      if (panel) {
        panel.style.pointerEvents = 'auto';
      }
    }

    function scheduleClose() {
      if (closeTimer) return;
      closeTimer = setTimeout(function () {
        try { menu.removeAttribute('open'); } catch(e){}
        menu.classList.remove('hover-open');
        if (panel) {
          panel.style.pointerEvents = '';
        }
        closeTimer = null;
      }, 260); // 260ms delay — állítható 150-350 ms között
    }

    menu.addEventListener('pointerenter', openMenu);
    menu.addEventListener('pointerleave', scheduleClose);

    if (panel) {
      panel.addEventListener('pointerenter', openMenu);
      panel.addEventListener('pointerleave', scheduleClose);
    }

    // keyboard support
    menu.addEventListener('focusin', openMenu);
    menu.addEventListener('focusout', function (ev) {
      if (!menu.contains(ev.relatedTarget)) scheduleClose();
    });
  });
});
